
const allPhrases = [
[
  {quote: "Vamos Começar?"},
  {quote: "Pronto para mais uma sessão de foco total?"},
  {quote: "Se arrume na cadeira, bloqueie o celular e vamos começar!"},
  {quote: "Preparado? Vamos lá!"}]
,
[
  {quote: "Hora de botar o celular de lado e estudar."},
  {quote: "Agora é para ignorar qualquer distração!"},
  {quote: "Momento de foco total agora!"},
  {quote: "Vamos lá, hora de estudar, só para quando ouvir o alarme!"}
],
[
  {quote: "Hora de levantar e alongar!"},
  {quote: "Que tal fazer algum exercício nessa pausa, uma caminhada já ajuda!"},
  {quote: "Aproveita esse tempinho pra pegar uma água, hidrate-se!"},
  {quote: "Ta bom, agora pode usar um pouco o celular!"}
],
[
  {quote: "Agora sim, hora de dar uma boa descansada!"},
  {quote: "Parabéns pelo esforço!! Hora de limpar um pouco a mente."},
  {quote: "Chegou a tão esperada pausa longa! Uma medição pode ser ótimo!"},
  {quote: "Hora de ver aquele vídeo no youtube, ou dar uma olhada no instagram!"}
]
,]

export default allPhrases;